import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    standalone: false,
    selector: 'cva-form-template',
    templateUrl: './form-template.component.html',
    styleUrl: './form-template.component.scss',
    
})
export class FormTemplateComponent {
  backgroundImage = `url('${environment.cvaUI_url}/assets/images/smiley-doctor-patient-chatting-medium-shot1.png') no-repeat center/cover`;
}
